import { Colors } from 'cio-design-library/design-tokens'
import { IVisualProps } from 'builder/components/CIO-Dasboard-2.0/types'
import NewTag from '../../Tags/NewTag'
import * as Styled from './styles'

export const JobFairsVisual = ({ imgUrl, alt }: IVisualProps) => {
  return (
    <Styled.VisualContainer>
      <NewTag color={Colors.Neutral40} />
      <Styled.VisualImageContainer>
        <Styled.VisualImage src={imgUrl} alt={alt} />
      </Styled.VisualImageContainer>
    </Styled.VisualContainer>
  )
}
